import { Box, Typography } from "@mui/material";

const BottomLabel = (item) => {
  if (!item) return null;

  const leftLines = [];
  const rightLines = [];

  // LEFT STACK
  if (item.donorId) leftLines.push(`#${item.donorId}`);
  leftLines.push(
    item.tributeName
      ? item.tributeName
      : `${item.salutation || ""} ${item.firstName || ""} ${item.lastName || ""}`.trim()
  );
  if (item.address) leftLines.push(item.address);
  if (item.address1) leftLines.push(item.address1);
  if (item.address2) leftLines.push(item.address2);
  if (item.city || item.pincode)
    leftLines.push(`${item.city || ""} ${item.pincode || ""}`.trim());

  if (item.mobile1 || item.mobile2) {
    leftLines.push(
      `Mob: ${[item.mobile1, item.mobile2].filter(Boolean).join(", ")}`
    );
  }

  // RIGHT STACK (Donation logic)
  if (item.sharma) rightLines.push(item.sharma);

  if (item.tamilMonths && item.nachathiram)
    rightLines.push(`${item.tamilMonths} ${item.nachathiram}`);
  else if (item.tamilMonths && item.thithi)
    rightLines.push(`${item.tamilMonths} ${item.thithi}`);
  else if (item.thithi) rightLines.push(item.thithi);
  else if (item.tamilMonths) rightLines.push(item.tamilMonths);
  else if (item.utsavam) rightLines.push(item.utsavam);
  else if (item.poojaDate) rightLines.push(item.poojaDate);

  return (
    <Box
      sx={{
      padding: 1,
        minHeight: "100px",
        border: "1px solid #ccc",
        height: "160px",
      }}
    >
      {/* LEFT */}
      <Box>
        {leftLines.map((line, idx) => (
          <Typography fontWeight="bold"
            key={`L${idx}`}
            sx={{  lineHeight: "1.2" }}
          >
            {line}
          </Typography>
        ))}
      </Box>

      {/* RIGHT (below, right aligned) */}
      {rightLines.length > 0 && (
        <Box
          sx={{
            mt: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {rightLines.map((line, idx) => (
            <Typography fontWeight="bold"
              key={`R${idx}`}
              sx={{  lineHeight: "1.2" }}
            >
              {line}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default BottomLabel;
